/* eslint-disable prettier/prettier */
import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

interface Props {
	backgroundImage: any;
}

export const FaqWrapper = styled.div<Props>`
	padding-top: 85px;
	.challenge-header {
		box-sizing: border-box;
		padding: 50px 0px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background-position: center;
		width: 100%;
		height: 248px;
		background-image: url(${(props) => props.backgroundImage});
		background-repeat: no-repeat;
		background-size: cover;
		position: relative;
		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(5, 27, 30, 0.6);
		}
		.challenge-name {
			width: 100%;
			max-width: 1260px;
			margin: 0 auto;
			font-family: 'Signifier-Regular';
			color: ${colors.white};
			font-size: 57px;
			font-style: normal;
			font-weight: 400;
			line-height: 64px;
			letter-spacing: -1.8px;
			z-index: 2;
		}
	}

	.content {
		display: flex;
		margin-top: 120px;
		.answers {
			width: 70%;
			.faq {
				margin-bottom: 100px;
				.title {
					margin-top: 0;
					font-family: 'Signifier-Regular';
					font-size: 2.25rem;
					line-height: 2.5rem;
					letter-spacing: -0.03em;
					color: ${colors.textDark};
				}
				.description {
					font-size: 1.2rem;
					line-height: 1.9rem;
					color: ${colors.textDark};
				}
			}
		}
		.questions {
			width: 30%;
			.selected {
				border-left: 2px solid ${colors.primary} !important;
				.title {
					opacity: 1 !important;
				}
			}
			.faq {
				padding: 10px 20px;
				border-left: 1px solid #c3dde0;
				cursor: pointer;
				.title {
					margin-top: 0;
					font-family: 'Signifier-Regular';
					font-size: 1.25rem;
					letter-spacing: -0.03em;
					color: ${colors.textDark};
					opacity: 0.7;
					margin: 0;
				}
			}
		}
	}

	.loading-center {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
		height: 400px;
		.MuiCircularProgress-colorInherit {
			color: ${colors.primary};
		}
	}

	@media ${device.tablet} {
		.content {
			padding: 20px;
			display: flex;
			flex-direction: column-reverse;
			margin-top: 50px;
			align-items: center;
			.answers {
				margin-top: 50px;
				width: 100%;
			}
			.questions {
				width: 100%;
			}
		}
	}

	@media ${device.mobile} {
		.content {
			padding: 20px;
			display: flex;
			flex-direction: column-reverse;
			margin-top: 50px;
			align-items: center;
			.answers {
				width: 100%;
				margin-top: 50px;
				.faq {
					margin-bottom: 50px;
					.title {
						margin-top: 0;
						font-family: 'Signifier-Regular';
						font-size: 2rem;
						line-height: 2.3rem;
						letter-spacing: -0.03em;
						color: ${colors.textDark};
					}
					.description {
						font-size: 1.1rem;
						line-height: 1.7rem;
						color: ${colors.textDark};
					}
				}
			}
			.questions {
				width: 100%;

				.faq {
					.title {
						margin-top: 0;
						font-family: 'Signifier-Regular';
						font-size: 1.2rem;
						letter-spacing: -0.03em;
						color: ${colors.textDark};
						opacity: 0.7;
						margin: 0;
					}
				}
			}
		}
	}
`;
